<script lang="ts">
	import { Mail } from 'lucide-svelte';

	export let compact = false;
</script>

{#if compact}
	<a
		href="https://dsarc.substack.com/"
		target="_blank"
		rel="noopener noreferrer"
		class="flex items-center space-x-2 hover:text-blue-300"
	>
		<Mail class="h-6 w-6" />
		<span class="font-medium">Substack</span>
	</a>
{:else}
	<a
		href="https://dsarc.substack.com/"
		target="_blank"
		rel="noopener noreferrer"
		class="flex items-center rounded-lg bg-gray-50 p-4 transition-colors hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600"
	>
		<Mail class="h-8 w-8 text-blue-700 dark:text-blue-300" />
		<div class="ml-4">
			<div class="font-medium">Subscribe on Substack</div>
			<p class="text-sm text-gray-600 dark:text-gray-300">
				Announcements, meeting notes, and event updates.
			</p>
		</div>
	</a>
{/if}
